import { Component, EventEmitter, Output } from '@angular/core';
import { AppStateService } from 'src/app/core/services';
import { ProductRoute } from '../../api-models/admin/product-route.enum';

@Component({
	selector: 'portal-audio-previewer',
	templateUrl: './audio-previewer.component.html'
})
export class AudioPreviewerComponent {
	@Output() handleCloseModal: EventEmitter<void> = new EventEmitter<void>();

	readonly productRoute = ProductRoute;

	constructor(public appStateService: AppStateService) {}

	public onClose(): void {
		this.handleCloseModal.emit();
	}
}
